import { render, staticRenderFns } from "./BpDropdownItem.vue?vue&type=template&id=c896a292&"
import script from "./BpDropdownItem.vue?vue&type=script&lang=js&"
export * from "./BpDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./BpDropdownItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports